import React from "react";
import {defineBlock} from "@smartfire/wordpress-react";
import style from "./block.module.scss";
import Logo from "../assets/logo.svg";
import {ReactComponent as Arrow} from "./arrow.svg";
import {ReactComponent as Linkedin} from "./linkedin.svg";
import Obfuscate from 'react-obfuscate';
import {ReactComponent as ArrowIcon} from "../assets/arrow.svg";
import { useTranslation } from 'react-i18next';


function Block({hideBesoinAide, custom_settings, menuBottom, menuTop, isHome, activeLang}){
    const {t} = useTranslation();

    return <div className={style.block}>

                {!hideBesoinAide &&
                <div className={`${style.top} ${isHome ? style.home : null}`}>
                    <div className={style.container}>
                        <div className={style.mediaContent}>
                            <img src={custom_settings.media_back} alt="Background pied de page" />
                        </div>
                        <div className={style.content}>
                            <h2 className={style.title}>{t("Besoin d’un conseil ?")}</h2>
                            <div className={style.descr}>{t("Les équipes Easycube sont à votre écoute !")}</div>
                            <a href={custom_settings.url_contact}>
                                <div className={style.buttonContainer}>
                                    <div className={style.button}>
                                        <ArrowIcon />{t("Contact")}
                                    </div>
                                </div>
                                </a>
                        </div>
                    </div>
                    <div className={style.blocBottom}></div>
                </div>
                }

                <div className={style.middle}>
                    <div className={style.container}>
                        <div className={style.col1}>
                            <div className={style.row1}>
                                <div className={style.logo}><a href={`/${activeLang === 'en' ? 'en' : ''}`}><img src={Logo} alt="Logo" /></a></div>
                                <div className={style.adress}>
                                    <div>{custom_settings.adress}</div>
                                    <div>{custom_settings.cp} {custom_settings.ville}</div>
                                </div>
                                { custom_settings.plan_acces ?
                                    <div className={style.acces}>
                                        <a href={custom_settings.plan_acces}>
                                            <Arrow />
                                            {t("Plan d'accès")}
                                        </a>
                                    </div> : null
                                }
                                <div className={style.phone}>{t("Tél :")} <Obfuscate tel={custom_settings.phone} /></div>
                                <div className={style.mail}>{t("E-mail :")} <Obfuscate email={custom_settings.mail} /></div>
                            </div>
                            <div className={style.row3}>
                                <div className={style.followLibelle}>{t("Suivez-nous")}</div>
                                <div className={style.socials}>
                                    <a className={style.linkedin} href={custom_settings.linkedin}><Linkedin /></a>
                                </div>
                            </div>
                        </div>

                        <div className={style.col2}>

                        <div className={style.row}>
                            {menuTop && Object.values(menuTop).map((item, index) => 
                                <>
                                    <div key={index} className={style.item}>
                                        <div className={style.title}>
                                            {
                                                item.classes && item.classes.includes('no-link') ? item.title : <a href={item.url}>{item.title}</a>
                                            }
                                            </div>
                                        {item.children ? Object.values(item.children).map((subItem, index) => 
                                            <div key={index} className={style.subItem}>
                                                {subItem.classes && !item.classes.includes('no-link') ? <a href={subItem.url}>{subItem.title} </a> : <>
                                                <div>{subItem.title}</div>
                                                {subItem.children ? Object.values(subItem.children).map((subSubItem, index) => 
                                                    <div key={index} className={style.subSubItem}>
                                                        <a href={subSubItem.url}>{subSubItem.title}</a>
                                                    </div>
                                                ) : ''}</>}
                                            </div>
                                        ) : ''}
                                    </div>
                                </>
                            )}
                        </div>
                    </div>
                    </div>
                </div>

                <div className={style.bottom}>
                    <div className={style.content}>
                        <div className={style.copyright}>© Easycube - 2020</div>
                        <div className={style.links}>
                            {Object.values(menuBottom).map((item, index) => 
                                <div key={index} className={style.item}>
                                    <a href={item.url}>{item.title}</a>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
        </div>
}

export default defineBlock({
    Block, 
    setup: {
        title: "Footer",
    }
});
